module.exports = __webpack_public_path__ + "static/media/cagliostro-win.2fff0e9a.png";